import styled from 'styled-components/native';

export default styled.Text<{ tintColor?: string }>`
  color: ${({ theme, tintColor }) => tintColor || theme.colors.text};
`;
